import { Feature } from "configuration";
import { ReactComponent as AdminSettingsIcon } from "icons/navbar/currentUserMenu/admin-settings.svg";
import { ReactComponent as BillingIcon } from "icons/navbar/currentUserMenu/billing.svg";
import { ReactComponent as UsersIcon } from "icons/navbar/currentUserMenu/user-management.svg";
import { ReactComponent as AnalyticsIcon } from "icons/navbar/routesMenuItems/analytics.svg";
import { ReactComponent as AppRecommenderIcon } from "icons/navbar/routesMenuItems/app-recommender.svg";
import { ReactComponent as AudienceIcon } from "icons/navbar/routesMenuItems/audiences.svg";
import { ReactComponent as CampaignsIcon } from "icons/navbar/routesMenuItems/campaigns.svg";
import { ReactComponent as CreativesIcon } from "icons/navbar/routesMenuItems/creatives.svg";
import { ReactComponent as TrafficIcon } from "icons/navbar/routesMenuItems/traffic.svg";

import { ADMIN_SETTINGS_USERS_WHITELIST, USER_ROLES } from "model/auth";
import React from "react";
import { isAlpha } from "../../configuration/endpoints";

export interface INavigationMenuItem {
  icon: React.ReactElement | null;
  label: string;
  name: string;
  route: string;
  whitelistRoles?: { [role: string]: boolean };
  blacklistRoles?: { [role: string]: boolean };
  //for items that no role can express, e.g. platform-wide admin pages
  whitelistUsers?: string[];
  sub?: string[];
  alphaOnly?: boolean;
  noAlphaFeatureFlag?: Feature;
  isHidden?: boolean;
}

const navigationMenuItems: INavigationMenuItem[] = [
  {
    route: "/campaigns",
    name: "campaigns",
    icon: <CampaignsIcon />,
    label: "Campaigns",
    blacklistRoles: {
      [USER_ROLES.FINANCE_ADMIN]: true,
    },
  },
  {
    route: "/analytics",
    name: "analytics",
    icon: <AnalyticsIcon />,
    label: "Analytics",
  },
  {
    route: "/app-intelligence",
    name: "appIntelligence",
    icon: <AppRecommenderIcon />,
    label: "App Intelligence",
    whitelistRoles: {
      [USER_ROLES.ADMIN]: true,
    },
  },
  {
    route: "/traffic",
    name: "traffic",
    icon: <TrafficIcon />,
    label: "Traffic",
    blacklistRoles: {
      [USER_ROLES.FINANCE_ADMIN]: true,
    },
  },
  {
    route: "/audiences",
    name: "audiences",
    icon: <AudienceIcon />,
    label: "Audiences",
    blacklistRoles: {
      [USER_ROLES.USER_READ_ONLY]: true,
      [USER_ROLES.FINANCE_ADMIN]: true,
    },
  },
  {
    route: "/creatives",
    name: "creatives",
    icon: <CreativesIcon />,
    label: "Creatives",
    sub: ["playable"],
    blacklistRoles: {
      [USER_ROLES.FINANCE_ADMIN]: true,
    },
  },
];

export const userMenuNavigationMenuItems: INavigationMenuItem[] = [
  {
    route: "/users",
    name: "users",
    icon: <UsersIcon />,
    label: "User Management",
    whitelistRoles: {
      [USER_ROLES.ADMIN]: true,
      [USER_ROLES.ORGANIZATION_ADMIN]: true,
    },
  },
  {
    route: "/billing/dashboard",
    name: "billing",
    icon: <BillingIcon />,
    label: "Billing",
    whitelistRoles: {
      [USER_ROLES.ADMIN]: true,
      [USER_ROLES.ORGANIZATION_ADMIN]: true,
      [USER_ROLES.FINANCE_ADMIN]: true,
    },
  },
  {
    route: "/admin-settings",
    name: "adminSettings",
    icon: <AdminSettingsIcon />,
    label: "Admin settings",
    whitelistUsers: ADMIN_SETTINGS_USERS_WHITELIST,
  },
];

export default navigationMenuItems;
